import React from "react";

const Areas = ({align, first, content}) => {
  return (
    <section className={`success-area`} >
      <div className="container">
        <div className="row align-items-center res-areas-container " style={{flexDirection: align ? "row-reverse" : "row", marginLeft: align ? "-140px": "0px"}}>
          <div className="col-lg-6 order-0 order-lg-2">
            <div className="success-img">
              <img src={content.img} alt="" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="success-content">
              <div className="section-title title-style-two mb-30">
                {/* <span className="sub-title">Something</span> */}
                <h3 className="title" style={{fontSize: "36px"}}>
                {content.heading}
                </h3>
              </div>
              <p className="success-para">
              {content.para}
              </p>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Areas;
